<template>

		<v-layout row wrap>
			<v-flex>
				<v-card>
					<v-card-text class="px-0">
						<v-form v-if="!hasResetRequest" class="pl-4 pr-4 pt-4 pb-4 noPaddingTopBottom">
							<p><br />Enter the email associated to the account, as well as your new password.</p>
							<v-flex lg12>
								<label class="blackLabel">Email Address:</label>
								<v-text-field autocomplete="off" label="Account email to reset" v-model="fPassEmail" :rules="emailRule" required solo></v-text-field>
							</v-flex><br />
							<v-flex lg12>
								<label class="blackLabel" style="display: inline !important">New Password:</label>
								<div class="custom-control custom-checkbox" style="display: inline !important; float: right">
									<label class="custom-control-label" for="checkbox-1">Show password</label>
									<input type="checkbox" class="custom-control-input" id="checkbox-1" v-model="checked">
								</div>
								<v-text-field autocomplete="off"  :type="checked ? 'text' : 'password'" label="New Password" v-model="fPassPass" :rules="fPassRules" required solo></v-text-field>
								<password style="max-width: 100%" v-model="fPassPass" :badge="false" :toggle="true" :secureLength="8" :strengthMeterOnly="true"/>
								<h5>Your password must contain:</h5>
								<p style="line-height: 14px;">
									<small :class="has_uppercase ? 'green--text' : 'red--text'">
										<v-icon small :color="has_uppercase ? 'green darken-2' : 'red darken-2'">{{has_uppercase ? 'check' : 'close'}}</v-icon>
										At least 1 capital letter
									</small> <br/>
									<small :class="has_number ? 'green--text' : 'red--text'">
										<v-icon small :color="has_number ? 'green darken-2' : 'red darken-2'">{{has_number ? 'check' : 'close'}}</v-icon>
										At least 1 number
									</small> <br/>
									<small :class="has_maximum_length ? 'green--text' : 'red--text'">
										<v-icon small :color="has_maximum_length ? 'green darken-2' : 'red darken-2'">{{has_maximum_length ? 'check' : 'close'}}</v-icon>
										Minimum of 8 characters
									</small>
								</p>
							</v-flex>

							<br />
							<v-btn color="success" v-if="!requestSent" class="text-xs-right fPassButton" @click.stop="fncRequestCode" :disabled="!hasRequestedCode">Request Reset Code</v-btn>
							<v-btn color="success" v-if="!requestSent" class="text-xs-right" @click.stop="fncHideModal">Cancel</v-btn>
							<v-progress-circular v-if="requestSent" indeterminate :width="3" :size="20" color="grey" class="pt-3 customLoader"></v-progress-circular>
							<div class="clearfix"></div>
						</v-form>
						<v-form v-model="hasResetPassword" v-if="hasResetRequest" class="hide pl-4 pr-4 pt-4 pb-4 noPaddingTopBottom">
							<br />
							<p v-if="!hasCodeEmailed">Select your account.</p>
							<p v-else>Enter the code that has been emailed to you</p>
							<v-select :items="userAccountList" v-model="fPassAccount" v-if="!hasCodeEmailed" @input="fncSendCode()" label="Select Account" autocomplete solo></v-select>
							<v-text-field autocomplete="off" label="Reset Code" v-if="hasCodeEmailed" v-model="fPassCode" required solo></v-text-field>
							<br />
							<v-btn color="success" class="text-xs-right fPassButton" v-if="hasCodeEmailed && !resetSent" :disabled="!hasCodeEmailed" @click.stop="fncResetPassword">Reset Password</v-btn>
							<v-btn color="success" class="text-xs-right cancelButton" @click.stop="fncHideModal">Cancel</v-btn>
							<v-progress-circular indeterminate :width="3" :size="20" v-if="resetSent" color="grey" class="pt-3 loginLoader"></v-progress-circular>
							<div class="clearfix"></div>
						</v-form>
					</v-card-text>
				</v-card>
			</v-flex>
		</v-layout>

</template>

<script>

import { mapGetters } from 'vuex';
import Password from 'vue-password-strength-meter';


export default{
  components: { Password },
	data () {
		return {
			hasRequestedCode: false,
			hasResetPassword: false,
			fPassPass: '',
            fPassEmail: this.$route.query.email != null ? this.$route.query.email : '',
			fPassCode: '',
			fPassAccount: '',
			emailRule: [
				v => !!v || 'Email is required',
				v => /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(v) || 'Email must be valid'
			],
			fPassRules: [
				v => !!v || 'Password is required'
			],
			score_results: 0,
			has_number: false,
			has_uppercase: false,
			has_maximum_length: false,
			value: true,
			checked: false
		};
	},
	computed: {
		...mapGetters([
			'hasResetRequest',
			'codeError',
			'requestSent',
			'resetSent',
			'userAccountList',
			'hasCodeEmailed',
			'loginId',
			'resetComplete',
			'resetError'
		])
	},
	props: ['dialog'],
	methods: {
		fncRequestCode () {
			this.$store.dispatch({
				type: 'fncRequestCode',
				email: this.fPassEmail,
				password: this.fPassPass,
			});
		},
		updateErrorStatus () {
			if (this.codeError === true) {
				this.$store.commit('updateErrorStatus');
			}
		},
		fncResetPassword () {
			var accountId = this.fPassAccount.id;
			if (this.loginId > 0) {
				accountId = this.loginId;
			}
			this.$store.dispatch({
				type: 'fncResetPassword',
				account: accountId,
				password: this.fPassPass,
				code: this.fPassCode
			});
		},
		fncSendCode () {
			this.$store.dispatch({
				type: 'fncSendCode',
				email: this.fPassEmail,
				account: this.fPassAccount.id
			});
		},
		fncHideModal () {
			this.$store.commit('hideModal');
			this.$store.commit('updatehasResetRequest');
			this.fPassPass = '';
            this.fPassEmail = this.$route.query.email != null ? this.$route.query.email : '';
			this.fPassCode = '';

		}
	},
  mounted() {
    this.updateErrorStatus();

    if (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(this.fPassEmail))
    {
      this.hasRequestedCode = true
    }
    else
    {
      this.hasRequestedCode = false
    }
  },
	watch: {
		fPassEmail () {
			this.updateErrorStatus();

			if (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(this.fPassEmail))
			{
				this.hasRequestedCode = true
			}
			else
			{
				this.hasRequestedCode = false
			}

		},
		loginId () {
			if (this.loginId !== 0) {
				this.$store.dispatch({
					type: 'fncSendCode',
					email: this.fPassEmail,
					account: this.loginId
				});
			}
		},
		resetComplete () {
			if (this.resetComplete === true) {
				this.$store.commit('hideModal');
				this.$store.commit('updatehasResetRequest');
				this.fPassPass = '';
				this.fPassEmail = '';
				this.fPassCode = '';
			}
		},
    fPassPass () {
			this.score_results = 0;

			this.has_number    = /\d/.test(this.fPassPass);
			this.score_results = this.has_number ? this.score_results+1 : this.score_results;

			this.has_uppercase = /[A-Z]/.test(this.fPassPass);
			this.score_results = this.has_uppercase ? this.score_results+1 : this.score_results;

			this.score_results = this.fPassPass.length > 7 ? this.score_results+1 : this.score_results;
			this.has_maximum_length = (this.fPassPass.length > 7 );
		}
    },
    created() {
    }
};

</script>

<style scoped>
	@import '../shared/assets/css/shared.css';
  .checkbox-lg .custom-control-label::before,
  .checkbox-lg .custom-control-label::after {
    top: .8rem;
    width: 1.55rem;
    height: 1.55rem;
  }

  .checkbox-lg .custom-control-label {
    padding-top: 13px;
    padding-left: 6px;
  }


  .checkbox-xl .custom-control-label::before,
  .checkbox-xl .custom-control-label::after {
    top: 1.2rem;
    width: 1.85rem;
    height: 1.85rem;
  }

  .checkbox-xl .custom-control-label {
    padding-top: 23px;
    padding-left: 10px;
  }
</style>
